


import useBaseApiHook, { BASE_API_CONSTANT } from "services/useBaseApiHook"

const REPO_URL = {
    getList: '/work-calendar/paginated',
    getById: '/work-calendar/id',
    create: '/work-calendar/save',
    update: '/work-calendar/update',
    delete: '/work-calendar/delete'  
}

const useWorkingcalendarRepo = (initialLoading = false) => {
    const { isLoading, data, error, executeApi } = useBaseApiHook(initialLoading)

    const getWorkCalList = async (payload) => {
        return await executeApi(REPO_URL.getList, BASE_API_CONSTANT.METHOD.POST, payload)
    }

    const getWorkCalById = async (payload) => {
        return await executeApi(REPO_URL.getById, BASE_API_CONSTANT.METHOD.POST, payload)
    }

    const createWorkCal = async (payload) => {
        return await executeApi(REPO_URL.create, BASE_API_CONSTANT.METHOD.POST, payload)
    }

    const updateWorkCal = async (payload) => {
        return await executeApi(REPO_URL.update, BASE_API_CONSTANT.METHOD.POST, payload)
    }

    
    const deleteWorkCal = async (payload) => {
        return await executeApi(REPO_URL.delete, BASE_API_CONSTANT.METHOD.POST, payload)
    }

    return {
        isLoading,
        data,
        error,
        getWorkCalList,
        getWorkCalById,
        createWorkCal,
        updateWorkCal,
        deleteWorkCal
    }
}

export default useWorkingcalendarRepo
